export function tableRowBackground(rowIndex: number | undefined): string {
    return ["#ffffff", "#f6f6f6"][(rowIndex ?? 0) % 2];
}
